import {neverland as $, render, html, useState, useEffect} from 'neverland';

import buildForm from '../tripetto-constructors/buildForm.js';
import { run } from "@tripetto/runner-autoscroll";


function randomString() {
	return Math.random().toString().substr(2, 10);
}

const Preview = $(function(
	auth,
	collection,
	setCollection,
	doc
	) {

	let { 
			preview,
			edit,
			docPaneID
		} = collection;



	function openEditor() {
		setCollection(prevCollection => {
			let collection = {...prevCollection};
			collection.edit = true;
			return collection;
		})
	}

	function closePreview() {

		setCollection(prevCollection => {
			let collection = {...prevCollection};
			collection.preview = false;
			if (!collection.edit) {
				collection.docID = null;
			}
			return collection;
		})
	}

	// Initialise Tripetto.
	useEffect(() => {

		if (preview) {

			let seq = doc.curr;
			let displayNums = false;
			if (collection.title == "Items") {
				seq.isItem = true;
				if (!seq.hasOwnProperty('id')) {
					seq.id = randomString();
				}
				seq = [seq];
			} else if (collection.title == "Item Sets") {
				seq = seq.elements;
				displayNums = true;
			}

			// Get Items and ItemSets data from collection's loaded reference data
			let itemsData = [];
			let itemSetsData = [];
			
			if (collection.fields && collection.fields.elements && collection.fields.elements.fields && collection.fields.elements.fields.element && collection.fields.elements.fields.element.options) {
				const options = collection.fields.elements.fields.element.options;
				itemsData = options.filter(opt => opt.collection === 'Items');
				itemSetsData = options.filter(opt => opt.collection === 'ItemSets');
			}

			let spec = {
				Items: itemsData,
				ItemSets: itemSetsData,
				ItemSet: {
					elements: seq,
					...doc.curr,
				}
			};


			for (let k = 0; k < 2; k++) { // Run twice to overcome a bug in which the React component did not update properly.
				run({
					element: document.querySelector('.preview'), /* Or supply your own element here */
					definition: buildForm(spec),
					styles: {
						direction: "vertical",
						verticalAlignment: "middle",
						hidePast: true,
						hideUpcoming: true,
						showNavigation: "never",
						showProgressbar: false,
						showEnumerators: displayNums ?? false,
						autoFocus: false,
						showSeparateSubmit: true,
						showPreviousButton: true,
						showScrollbar: false,
						disableScrolling: false,
						noBranding: true,
						hideRequiredIndicator: true,
						contract: {
							name: "@tripetto/runner-autoscroll",
							version: "9.0.1"
						}
					},
					onSubmit: (instance) => {
						// TODO: Handle the results
						// For example retrieve the results as a CSV-file:
						// const csv = Export.CSV(instance);
						// // Or retrieve the individual fields:
						// const fields = Export.fields(instance);
					}
				});
			}

		}


	}, [preview,
		docPaneID,
		collection.docID,
		doc.curr.type,
		doc.curr.prompt,
		doc.curr.caption,
		doc.curr.explanation,
		doc.curr.description,
		doc.curr.options,
		doc.curr.precision,
		doc.curr.maxChar,
		doc.curr.minChar,
		doc.curr.isDigits,
		doc.curr.elements])

	// Add custom CSS.
	useEffect(() => {
		let iframe = document.querySelector(".preview iframe");
		if (iframe !== null) {
			let sheets = document.styleSheets,
				existingLinks = iframe.contentDocument.querySelectorAll("link");
			
			if (existingLinks.length == 0) {
				// Re-add stylesheets.
				for (let { href } of sheets) {
					if (href !== null) {
						const link = document.createElement("link");
						link.href = href;
						link.rel = "stylesheet";
						iframe.contentDocument.body.appendChild(link);
					}
				}
			}
		}
	}, [collection.docPaneID])

	return html`
		<div class="controls">

			<h1>Preview</h1>

			<div class="buttons">
				<button class="" onclick="${closePreview}">
					Close
				</button>
				${!edit && auth.isAdmin ? html`
					<button class="blue" onclick="${openEditor}">
						Edit
					</button>
				` : ''}
			</div>
		</div>

		<div class="preview"></div>
	`;

});

export default Preview;